export const RESULTS_MODAL_ACTION_TYPES = {
    SET_RESULTS_MODAL_WORKFLOW_STARTED: "SET_RESULTS_MODAL_WORKFLOW_STARTED",
    SET_METAL_CHOICES_VISIBLE: "SET_METAL_CHOICES_VISIBLE",
    SET_THICKNESS_CHOICES_VISIBLE: "SET_THICKNESS_CHOICES_VISIBLE",
    SET_QUANTITY_CHOICES_VISIBLE: "SET_QUANTITY_CHOICES_VISIBLE",
    RESET_RESULTS_MODAL: "RESET_RESULTS_MODAL"
}